import React from 'react';
import PropTypes from 'prop-types';
import {
  Row,
  Col
} from 'reactstrap';
import { Link } from 'react-router-dom';
import withRoleRestrictions from '../shared/withRoleRestrictions';
import withEulaRestrictions from '../license/withEulaRestrictions';
import { SPRUCE_ADMINS } from '../../constants/userRoles';
import messages from '../../constants/messages';
import {
  notifyInfo,
  notifyError
} from '../../utils/notifier';
import Button from '../shared/Button';
import {
  fetchCompanies,
  activateCompany,
  deactivateCompany
} from '../../actions/companies/apiRequests';
import { deserializeCompany } from '../../actions/companies/serializers';
import Page from '../shared/Page';
import Loader from '../shared/Loader';
import ActionModal from '../shared/ActivationModal';
import Pagination from '../shared/Pagination';
import CompaniesListTable from './CompaniesListTable';
import CompaniesListFilter from './CompaniesListFilter';
import { getBreadCrumbs } from '../../utils/breadCrumbs';
import {
  DASHBOARD,
  PAGE_PATHS
} from '../../constants/pathsRoots';


const PAGE_SIZE = 20;

export class CompaniesListPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      companies: [],
      filters: {
        query: '',
        enabled: null
      },
      page: 1,
      size: 1,
      pageCount: 1,
      totalCount: null,
      loading: true,
      showActivationModal: false,
      action: {}
    };

    this.fetchResults = this.fetchResults.bind(this);
    this.onChangePage = this.onChangePage.bind(this);
    this.onChangeFilter = this.onChangeFilter.bind(this);
    this.toggleActivationModal = this.toggleActivationModal.bind(this);
    this.onStatusChangeSuccess = this.onStatusChangeSuccess.bind(this);
    this.onStatusChangeError = this.onStatusChangeError.bind(this);
  }

  static get propTypes() {
    return {
      location: PropTypes.object
    }
  }

  get actions() {
    return [
      <Link to='/company' key='add'>
        <Button kind='primary' className='mr-1'>Add company</Button>
      </Link>
    ];
  }

  componentDidMount() {
    this.fetchResults(this.state.page);
  }

  fetchResults(page) {
    const {
      query,
      enabled
    } = this.state.filters;

    this.setState({ loading: true });

    return fetchCompanies(page, PAGE_SIZE, query, enabled)
      .then(({
        data,
        page,
        size,
        pageCount,
        totalCount
      }) => this.setState({
        page,
        size,
        pageCount,
        totalCount,
        companies: data.map(deserializeCompany),
        loading: false
      }))
      .catch(() => {
        this.setState({ loading: false });
        notifyError(messages.request.companiesListError);
      });
  }

  onChangePage(page) {
    window.scrollTo(0, 0);
    this.fetchResults(page)
      .then(this.setState({ page }));
  }

  onChangeFilter(filter, value) {
    this.setState((state) => ({
      filters: {
        ...state.filters,
        [filter]: value
      }
    }));
  }

  toggleActivationModal(companyId, companyEnabled) {
    this.setState(({ showActivationModal }) => ({
      showActivationModal: !showActivationModal,
      action: {
        companyId,
        companyEnabled
      }
    }));
  }

  onStatusChangeSuccess() {
    this.setState((prevState) => ({
      users: prevState.companies.map((company) => {
        if (company.id === prevState.action.companyId) {
          company.enabled = !company.enabled;
        }
        return company;
      })
    }));
    this.toggleActivationModal();
    notifyInfo(messages.common.saveSuccess);
  }

  onStatusChangeError() {
    this.toggleActivationModal();
    notifyError(messages.common.error);
  }

  render() {
    const {
      loading,
      companies,
      page,
      size,
      totalCount,
      pageCount,
      filters,
      action,
      showActivationModal
    } = this.state;
    const { pathname } = this.props.location;
    const hasResults = companies && companies.length;
    const itemsFrom = page * size  - size + 1;
    let itemTo = page * size;
    if (totalCount - page * size < 0) {
      itemTo = totalCount;
    }

    return (
      <Page
        header='Manage Companies'
        actions={this.actions}
        breadCrumbs={getBreadCrumbs('Manage Companies', pathname, [PAGE_PATHS[DASHBOARD]])}
      >
        <Row>
          <Col>
            <CompaniesListFilter
              query={filters.query}
              enabled={filters.enabled}
              onChangeFilter={this.onChangeFilter}
              onSubmit={this.fetchResults}
            />
          </Col>
        </Row>
        <If condition={totalCount>0}>
          <Row>
            <div className='ml-3 col-md-3'>
              <p>{`${itemsFrom} — ${itemTo} out of ${totalCount} results`}</p>
            </div>
          </Row>
        </If>
        <Choose>
          <When condition={!loading && (!hasResults)}>
            <div className='text-center my-5 py-5'>
              No companies found
            </div>
          </When>
          <Otherwise>
            <Row className='mb-2'>
              <Col>
                <If condition={hasResults}>
                  <CompaniesListTable
                    companies={companies}
                    onChangeStatus={this.toggleActivationModal}
                  />
                </If>
              </Col>
            </Row>
            <Row>
              <Col>
                <Choose>
                  <When condition={loading}>
                      <Loader />
                  </When>
                  <Otherwise>
                    <If condition={pageCount > 1}>
                      <Pagination
                        activePage={page}
                        itemsCountPerPage={PAGE_SIZE}
                        totalItemsCount={totalCount}
                        onChange={this.onChangePage}
                      />
                    </If>
                  </Otherwise>
                </Choose>
              </Col>
            </Row>
          </Otherwise>
        </Choose>
        <ActionModal
          message={`Are you sure you want to ${action.companyEnabled ? 'deactivate' : 'activate'} this company?`}
          isOpen={showActivationModal}
          action={() => action.companyEnabled ? deactivateCompany(action.companyId) : activateCompany(action.companyId)}
          onCancel={this.toggleActivationModal}
          onSuccess={this.onStatusChangeSuccess}
          onError={this.onStatusChangeError}
        />
      </Page>
    );
  }
}


export default withEulaRestrictions(withRoleRestrictions(CompaniesListPage, SPRUCE_ADMINS));



// WEBPACK FOOTER //
// src/components/companiesList/CompaniesListPage.jsx